module.exports = __webpack_public_path__ + "img/ic_bills_large.39b3f9a.svg";